import React from 'react';
import { IIconProps, sizeMap } from './types';

export const HomeIcon = ({ className, size = 'medium' }: IIconProps) => (
  <svg
    className={className}
    width={sizeMap[size].width}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6667 23V13.8333H8.33333V23M1 8.33333V23H23V8.33333L12 1L1 8.33333Z"
      stroke="currentcolor"
      strokeWidth={sizeMap[size].strokeWidth}
    />
  </svg>
);
